import "core-js/modules/es.array.reduce.js";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var create = function create(breakpoints, type) {
  return Object.entries(breakpoints).reduce(function (mediaObject, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        breakpoint = _ref2[0],
        value = _ref2[1];

    return _extends({}, mediaObject, _defineProperty({}, breakpoint, "@media (" + type + "-width: " + value + "px)"));
  }, {});
};

var breakpoints = {
  xsmall: 420,
  small: 576,
  medium: 768,
  large: 992,
  xlarge: 1200
};
var mediaMax = create(breakpoints, 'max');
var mediaMin = create(breakpoints, 'min');

var compose = function compose(obj1, obj2) {
  return Object.assign(obj1, obj2);
};

export { mediaMax, mediaMin, breakpoints, compose, create };